import React from 'react';
import { Text } from '@hangar/web-components/core/Text';
import { IconButton } from '@hangar/web-components/core/IconButton';
import { ChevronLeftOutlined } from '@hangar/react-icons/core/interaction/ChevronLeftOutlined';
import { ChevronRightOutlined } from '@hangar/react-icons/core/interaction/ChevronRightOutlined';
import * as S from './FlightChangesCases.styles';

export interface FlightChangesCasesTablePaginationProps {
    count: number;
    /** Zero-based page index */
    page: number;
    onPageChange: (newPage: number) => void;
    rowsPerPage: number;
    onRowsPerPageChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    rowsPerPageOptions: number[];
    labelRowsPerPage: string;
    labelDisplayedRows: (params: { from: number; to: number; count: number }) => string;
}

export const FlightChangesCasesTablePagination = ({
    count,
    page,
    onPageChange,
    rowsPerPage,
    onRowsPerPageChange,
    rowsPerPageOptions,
    labelRowsPerPage,
    labelDisplayedRows,
}: FlightChangesCasesTablePaginationProps) => {
    const from = count === 0 ? 0 : page * rowsPerPage + 1;
    const to = count === 0 ? 0 : Math.min(count, (page + 1) * rowsPerPage);
    const lastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
    const canPrev = page > 0;
    const canNext = page < lastPage;

    return (
        <S.PaginationControls>
            <S.PaginationRowsGroup>
                <Text variant="label-sm">{labelRowsPerPage}</Text>
                <S.PaginationNativeSelect
                    value={rowsPerPage}
                    onChange={onRowsPerPageChange}
                    aria-label={labelRowsPerPage}
                >
                    {rowsPerPageOptions.map((n) => (
                        <option key={n} value={n}>
                            {n}
                        </option>
                    ))}
                </S.PaginationNativeSelect>
            </S.PaginationRowsGroup>
            <Text variant="label-sm">{labelDisplayedRows({ from, to, count })}</Text>
            <S.PaginationNav>
                <IconButton
                    type="button"
                    variant="secondary"
                    size="compact"
                    icon={ChevronLeftOutlined}
                    disabled={!canPrev}
                    onClick={() => onPageChange(page - 1)}
                    aria-label="Previous page"
                />
                <IconButton
                    type="button"
                    variant="secondary"
                    size="compact"
                    icon={ChevronRightOutlined}
                    disabled={!canNext}
                    onClick={() => onPageChange(page + 1)}
                    aria-label="Next page"
                />
            </S.PaginationNav>
        </S.PaginationControls>
    );
};
